module.exports = __webpack_public_path__ + "static/media/red-hat.59e8a7fc.svg";